import {
  blue500,
  gray1300,
  gray200,
  green700,
  green200,
  coral500,
  purple200,
  whiteAlpha500,
  whiteAlpha800,
  whiteAlpha900,
  whiteBase,
  themes,
  whiteAlpha1000,
  coral300,
  colors,
} from '@mentimeter/ragnar-colors';
import type { Colors } from '@mentimeter/ragnar-dsc';

export type ThemeT =
  | 'balloon'
  | 'brand'
  | 'dark'
  | 'green'
  | 'greenDark'
  | 'greenLight'
  | 'pattern'
  | 'patternGreen'
  | 'patternGreenCTA'
  | 'patternYellowCTA'
  | 'patternPurpleCTA'
  | 'pink'
  | 'pinkLight'
  | 'plain'
  | 'purple'
  | 'purpleDark'
  | 'purpleLight'
  | 'shade'
  | 'yellow';

// Define a mapped type for CONTENT_THEME
type ContentThemeType = {
  [K in ThemeT]: { colors: Colors };
};

export interface CustomContentThemeType {
  theme?:
    | {
        colors: ThemeT;
      }
    | undefined;
}

// Update CONTENT_THEME to use the mapped type
export const CONTENT_THEME: ContentThemeType = {
  ...themes,
  dark: { colors: { ...themes.dark.colors, bg: gray1300 } },
  brand: {
    colors: {
      ...themes.primary.colors,
      borderPrimaryWeakest: whiteAlpha500,
    },
  },
  yellow: {
    colors: {
      ...themes.notice.colors,
      borderPrimaryWeakest: whiteAlpha900,
    },
  },
  green: {
    colors: {
      ...themes.positive.colors,
      borderPrimaryWeakest: whiteAlpha500,
    },
  },
  greenLight: {
    colors: {
      ...themes.neutral.colors,
      bg: green200,
      borderPrimaryWeakest: whiteAlpha800,
    },
  },
  greenDark: {
    colors: {
      ...themes.primary.colors,
      bg: green700,
      borderPrimaryWeakest: whiteAlpha500,
    },
  },
  pink: {
    colors: {
      ...themes.notice.colors,
      bg: coral500,
      borderPrimaryWeakest: whiteAlpha800,
    },
  },
  pinkLight: {
    colors: {
      ...themes.neutral.colors,
      bg: coral300,
      borderPrimaryWeakest: whiteAlpha900,
    },
  },
  purple: {
    colors: {
      ...themes.info.colors,
      borderPrimaryWeakest: whiteAlpha500,
      text: whiteBase,
      textWeak: whiteAlpha1000,
    },
  },
  purpleLight: {
    colors: {
      ...themes.neutral.colors,
      bg: purple200,
      borderPrimaryWeakest: whiteAlpha800,
    },
  },
  purpleDark: {
    colors: {
      ...themes.info.colors,
      borderPrimaryWeakest: whiteAlpha500,
      bg: gray1300,
      text: whiteBase,
      textWeak: whiteAlpha1000,
    },
  },
  plain: {
    colors: {
      ...themes.neutral.colors,
      bg: gray200,
      primary: blue500,
    },
  },
  shade: {
    colors: {
      ...themes.neutral.colors,
      bg: gray200,
      primary: blue500,
    },
  },
  balloon: {
    colors: {
      ...themes.neutral.colors,
      bg: colors.negativeWeak,
      borderPrimaryWeakest: whiteAlpha900,
    },
  },

  pattern: { ...themes.positive },
  patternGreen: { ...themes.positive },
  patternGreenCTA: { ...themes.positive },
  patternYellowCTA: { ...themes.positive },
  patternPurpleCTA: { ...themes.positive },
};
